import { Popover as OrbitBase } from "../../original/js/components/popover";
import ElementHelpers from "../../original/js/libraries/element-helpers";


export class Popover extends OrbitBase {

	constructor(element) {
		super(element)

    this.closeButtons = element.querySelectorAll('[data-rs-popover-button-close]')
    this.triggerParent = this.trigger.offsetParent
		this.addAdditionalEventHandlers()
	}
	/**
   * Declare classes
   */
	get classes() {
		return {
			popoverActive: 'popover--active',
			modalOverlayActive: 'modal__overlay--active',
      active: 'active',
			triggerActive: 'trigger--active',
      bodyClass: 'popover-open'
		}
	}

  /**
	 * Add event handlers
	 */

	addAdditionalEventHandlers() {

		if (this.trigger !== null) {
			this.trigger.addEventListener('click', e => {
        e.preventDefault();
				// Edit by ppetkov - RBD-3308: Prevent multiple active popovers.
				let activeTriggers = document.querySelectorAll(
          `[${this.attributes.trigger}].${this.classes.triggerActive}`
        );

				activeTriggers.forEach(el => {

					let activePopover = ElementHelpers.getElementByAttribute(
            "data-rs-popover",
            el.getAttribute(this.attributes.trigger)
					);
					activePopover.classList.remove(this.classes.popoverActive);
					el.classList.remove(this.classes.triggerActive);
				})
			});
		}

    // Edit by psavov - DERBR-2909: Make "data-rs-popover-button-close" attr - to close popover on select action btn.
    if (this.closeButtons) {
      this.closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
          this.closePopover(this.popoverOpen);
        })
      })
    }
	}

  /**
   * Add event handlers
   */
  addEventHandlers() {
    if (this.trigger) {
      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.popoverOpen) {
          this.openPopover(this.element);
        } else {
          this.closePopover(this.popoverOpen);
        }
        this.toggleActiveClassOnTrigger();
      });
    }

    if (this.overlay && !this.disableOverlay && this.popoverOpen) {
      this.overlay.addEventListener('click', () => {
        this.closePopover(this.popoverOpen);

        if (this.trigger) {
          this.toggleActiveClassOnTrigger();
        }
      });
    } else {
      window.addEventListener('click', clickEvent => {
        if (!this.popoverOpen) {
          return;
        }

        // Edit by psavov - DERBR-2909: Fixed close modal on click autosuggest item.
        var targetAttr = clickEvent.target.hasAttribute('data-rs-auto-suggest-list-value');
        var parentTargetAttr = clickEvent.target.parentElement
          ? clickEvent.target.parentElement.hasAttribute('data-rs-auto-suggest-list-value')
          : false;
        var closeModal = targetAttr || parentTargetAttr;

        if (
          (this.trigger && this.trigger.contains(clickEvent.target)) ||
          this.popoverOpen.contains(clickEvent.target) ||
          closeModal
        ) {
          return;
        }

        this.closePopover(this.popoverOpen);

        if (this.trigger) {
          this.toggleActiveClassOnTrigger();
        }
      });
    }

    document.addEventListener('keydown', keydownEvent => {
      this.handleButtonKeys(keydownEvent);
    });
  }

  openPopover(activePopover) {
    if (!activePopover) {
      return;
    }
    activePopover.classList.add(this.classes.popoverActive);
    activePopover.removeAttribute(this.attributes.hidden);
    // Edit by psavov - RXPIP-1266: Fixed arrow icon on toggle - add trigger--active class.
    this.triggerParent && this.triggerParent.classList.add(this.classes.triggerActive);

    if (this.overlay !== null && !this.disableOverlay) {
      this.overlay.classList.add(this.classes.modalOverlayActive);
    }

    document.querySelector('body').classList.add(this.classes.bodyClass);
    this.popoverOpen = activePopover;
  }

  closePopover(activePopover) {
    if (!activePopover) {
      return;
    }
    activePopover.classList.remove(this.classes.popoverActive);
    activePopover.setAttribute(this.attributes.hidden, 'true');
    // Edit by psavov - RXPIP-1266: Fixed arrow icon on toggle - remove trigger--active class.
    this.triggerParent && this.triggerParent.classList.remove(this.classes.triggerActive);

    if (this.overlay && !this.disableOverlay) {
      this.overlay.classList.remove(this.classes.modalOverlayActive);
    }

    document.querySelector('body').classList.remove(this.classes.bodyClass);
    this.popoverOpen = false;
    this.keystroke = 0;
  }
}
